import { Defaults } from 'es-decorators'
import { View } from 'es6/components/view'
import { Settlements } from 'es6/collections/settlements'
import $ from 'init/jquery'
import 'es6/libs/jq-autocomplete'
import { SettlementForm } from 'es6/models/settlement-form'
import { getSettlementString } from 'helpers/string-helpers'

/**
 * Вид для автозаполнения города
 */
@Defaults({
  additionalOptions: ['excludeSettlementIds', 'isNewCityForm'],
})
export class SettlementAutocompleteView extends View {
  /**
   * @inheritDoc
   */
  run () {
    if (!(this.settlement instanceof Object && this.settlement.attributes)) {
      this.settlement = new SettlementForm(this.settlement)
    }
    this.settlemntId = this.settlement.get('settlement_id')
    let that = this,
      classPostfix = this.$el.id,
      autocomplete = this.$el.autocomplete({
        source: this.getAvailableCities.bind(this),
        minLength: 2,
        select (event, ui) {
          that.$el.data('settlement-id', ui.item.id)
          that.lastSettlementId = ui.item.id

          // Сохранение названия города и области
          that.$el.data('settlement-name', ui.item.label)
          that.trigger('autocompleteDone', ui.item.id, ui.item.model)
        },
        change: this.changeSelected.bind(this),
        search (event) {
          if ($(event.currentTarget).val() === that.$el.data('settlement-name')) {
            return false
          }
        },
      })
    if (autocomplete && autocomplete.data('ui-autocomplete')) {
      autocomplete.data('ui-autocomplete')._resizeMenu = function () {
        return false
      }
      autocomplete.data('ui-autocomplete')._renderItem = function (ul, item) {
        $(ul[0]).addClass('autocomplete-' + classPostfix)
        let $a = $('<span></span>').text(item.label)
        that.highlightText(this.term, $a)
        return $('<li></li>')
          .data('settlement-id', item.id)
          .append($a)
          .appendTo(ul)
      }
    }

    this.collection = new Settlements(null, { user: this.user })
  }

  /**
   * Берет другой город, если автоселект не вернул значение.
   * @param {Object} event Объект события.
   * @param {Object} selectedCity Выбранный город.
   */
  changeSelected (event, selectedCity) {
    // Если автоселект не вернул город
    if (selectedCity.item === null && !this.isNewCityForm) {
      const actualSettlementId = this.settlement.get('settlement_id')
      const needChangeSettlement = this.settlementId !== actualSettlementId

      // Если нет сохраненных данных или изменился город, берем из модели
      if (!this.$el.data('settlement-name') || needChangeSettlement) {
        let nameAndRegion = getSettlementString(this.settlement)
        this.$el.data('settlement-name', nameAndRegion)

        // Если изменился город, сохраняем текущий
        if (needChangeSettlement) {
          this.settlementId = actualSettlementId
        }
      }
      // Вставляем в инпут сохраненные данные
      if (!this.lastSettlementId) {
        this.lastSettlementId = Boolean(actualSettlementId) && actualSettlementId
      }
      this.$el.val(this.$el.data('settlement-name'))
      this.$el.data('settlement-ids')
      this.trigger('autocompleteDone', this.lastSettlementId)
    }
  }

  /**
   * Получение доступных городов
   * @param {Object} request
   * @param {Object} response
   */
  getAvailableCities (request, response) {
    let el = this.$el.eq(0)
    if (el.data('lastRequest') === request.term) {
      return
    }

    let term = request.term.trim()
    if (term !== '') {
      this.collection.fetch({
        success: this.success.bind(this, response),
        data: { name: term, 'per_page': 50 },
      })
    }
    el.data('lastRequest', request.term)
  }

  /**
   * Обработка успешного запроса городов
   * @param {Function} response
   */
  success (response) {
    let availableCities = []
    this.collection.each(element => {
      let data = [],
        villageMark,
        region
      data.model = element
      data.value = ''

      if (this.excludeSettlementIds && this.excludeSettlementIds.indexOf(element.get('id')) !== -1) {
        return
      }
      villageMark = element.get('type') === 'village' ? 'д. ' : ''
      region = element.get('region') || ''

      data.value = `${villageMark}${element.get('name')} (${region})`
      data.id = element.get('id')

      availableCities[availableCities.length] = data
    })
    if (availableCities.length) {
      $('.choice-city_autocomplete').removeClass('not_display')
    }
    response(availableCities)
  }

  /**
   * Выделение введенной части при выборе города
   * @param {string} text
   * @param {jQuery} $node
   */
  highlightText (text, $node) {
    let searchText = $.trim(text).toLowerCase(),
      currentNode = $node.get(0).firstChild,
      matchIndex,
      newTextNode,
      newSpanNode

    while ((matchIndex = currentNode.data.toLowerCase().indexOf(searchText)) >= 0) {
      newTextNode = currentNode.splitText(matchIndex)
      currentNode = newTextNode.splitText(searchText.length)
      newSpanNode = document.createElement('span')
      newSpanNode.className = 'b'
      currentNode.parentNode.insertBefore(newSpanNode, currentNode)
      newSpanNode.appendChild(newTextNode)
    }
  }
}
